// extracted by mini-css-extract-plugin
module.exports = {"mainSettings":"MainSettings_mainSettings__2kURP","options":"MainSettings_options__3bZZ7"};